import axios from '../../admin-axios';
import { detectError } from '../../utils';
import ActionType from '../action-types';

// eslint-disable-next-line import/prefer-default-export
export const getStaffs = (stationId, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_STAFFS_START,
      payload: { page }
    });

    try {
      // send request to get staffs
      const response = await axios.get(`/staff/${stationId}?page=${page}`);
      dispatch({
        type: ActionType.FETCH_STAFFS_SUCCESS,
        payload: {
          staffs: response.data.data.data,
          total: response.data.data.total,
          per_page: response.data.data.per_page
        } // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.FETCH_STAFFS_ERROR,
        payload: message
      });
    }
  };
};

export const searchStaffs = (stationId, query, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.STAFF_SEARCH_START,
      payload: { page }
    });

    try {
      // send request to get staffs
      const response = await axios.get(`/staff/search/${query}/${stationId}?page=${page}`);
      dispatch({
        type: ActionType.STAFF_SEARCH_SUCCESS,
        payload: {
          searchResults: response.data.data.data,
          total: response.data.data.total,
          per_page: response.data.data.per_page
        } // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.STAFF_SEARCH_ERROR,
        payload: message
      });
    }
  };
};

export const setStaffView = (view) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.SET_STAFF_VIEW,
      payload: { view }
    });
  };
};
